import ChangePrice from './component'

export default ChangePrice
